// extracted by mini-css-extract-plugin
module.exports = {"logo_main":"Header_logo_main__3q_hF"};